<template>
	<div class="accordion-item" :id="uniqueId">
		<div class="card">
			<!--
                Clicking on the card header expands/collapses the card content (card body and card footer). Bootstrap's
                built-in Collapse capabilities (https://getbootstrap.com/docs/4.1/components/collapse/) are used to
                control the expanding/collapsing of the card content. But that is insufficient to also animate the
                rotation of the chevron, which is performed by listenting for Bootstrap events; see the `mounted()`
                lifecycle method.
			-->
			<div
				:class="['card-header', { expanded }]"
				data-toggle="collapse"
				:data-target="contentSelector"
				aria-expanded="false"
				:aria-controls="uniqueId"
				ref="cardHeader"
				v-html="$props.title"
			></div>

			<!-- Wrap the card body and footer in a single element that can be expanded/collapsed. -->
			<div :class="['collapse', { show: expanded }]">
				<div class="card-body" v-html="content"></div>
			</div>
		</div>
	</div>
</template>

<script>
import $ from 'jquery';
import Vue from 'vue';

let uniqueIndex = 0;

export default {
	props: {
		expanded: {
			default: false,
			type: Boolean,
		},
		title: {
			required: true,
		},
		content: {
			required: true,
		},
	},

	data() {
		return {
			uniqueId: `accordion-unique-id-${uniqueIndex++}`,
		};
	},

	computed: {
		contentSelector() {
			return `#${this.uniqueId} .collapse`;
		},

		headerSelector() {
			return `#${this.uniqueId} .card-header`;
		},
	},

	mounted() {
		this.$nextTick(() => {
			$(this.contentSelector).on('show.bs.collapse', () =>
				$(this.headerSelector).addClass('expanded'),
			);
			$(this.contentSelector).on('hide.bs.collapse', () =>
				$(this.headerSelector).removeClass('expanded'),
			);
		});
	},
};
</script>

<style lang="scss" scope>
.accordion-item {
	margin-bottom: 10px;
}

.accordion-item .card {
	border-radius: 0px;
	box-shadow: none;
	border: 0px;
	background-color: #ffffff;

	.card-header {
		background-color: #f5f5f5;
		color: #266294;
		border-radius: 0;
		border: 0px;
		height: 50px;
		line-height: 50px;
		vertical-align: middle;
		font-size: 18px;
		font-weight: bold;
		text-transform: uppercase;
		text-decoration: none;

		&.expanded,
		&:hover {
			background-color: #e1f7fe;
			color: #1f98be;
			transition: all 0.25s ease 0s !important;

			&:before {
				// background-color: #e1f7fe !important;
			}
		}

		&:before {
			display: inline-block !important;
			background-color: #266294 !important;
			color: #ffffff !important;
			margin: 0px 10px 0px -15px !important;
			padding: 5px 15px 15px 5px !important;
			height: 50px !important;
			width: 50px !important;
			background-repeat: no-repeat;
			transition: none;
		}
	}

	.card-body {
		font-size: 14px;
		// padding-left: 0px;
		// padding-right: 0px;
	}
}
</style>